import type { Language } from "@templestay/i18n";

const NATIONALITY_NAMES: Record<string, Record<Language, string>> = {
  KR: { ko: "한국", en: "South Korea", zh: "韩国", ja: "韓国" },
  CN: { ko: "중국", en: "China", zh: "中国", ja: "中国" },
  JP: { ko: "일본", en: "Japan", zh: "日本", ja: "日本" },
  US: { ko: "미국", en: "United States", zh: "美国", ja: "アメリカ" },
  GB: { ko: "영국", en: "United Kingdom", zh: "英国", ja: "イギリス" },
  FR: { ko: "프랑스", en: "France", zh: "法国", ja: "フランス" },
  DE: { ko: "독일", en: "Germany", zh: "德国", ja: "ドイツ" },
  AU: { ko: "호주", en: "Australia", zh: "澳大利亚", ja: "オーストラリア" },
  CA: { ko: "캐나다", en: "Canada", zh: "加拿大", ja: "カナダ" },
  TW: { ko: "대만", en: "Taiwan", zh: "台湾", ja: "台湾" },
  HK: { ko: "홍콩", en: "Hong Kong", zh: "香港", ja: "香港" },
  SG: { ko: "싱가포르", en: "Singapore", zh: "新加坡", ja: "シンガポール" },
  VN: { ko: "베트남", en: "Vietnam", zh: "越南", ja: "ベトナム" },
  TH: { ko: "태국", en: "Thailand", zh: "泰国", ja: "タイ" },
  PH: { ko: "필리핀", en: "Philippines", zh: "菲律宾", ja: "フィリピン" },
  IN: { ko: "인도", en: "India", zh: "印度", ja: "インド" },
  MX: { ko: "멕시코", en: "Mexico", zh: "墨西哥", ja: "メキシコ" },
  BR: { ko: "브라질", en: "Brazil", zh: "巴西", ja: "ブラジル" },
  OTHER: { ko: "기타", en: "Other", zh: "其他", ja: "その他" },
};

export function getNationalityOptions(lang: Language): { value: string; label: string }[] {
  return [
    { value: "", label: { ko: "선택 안 함", en: "Prefer not to say", zh: "不填写", ja: "選択しない" }[lang] },
    ...Object.entries(NATIONALITY_NAMES).map(([, names]) => ({
      value: names.ko, // 저장값은 한국어 (canonical)
      label: names[lang],
    })),
  ];
}
